import React from 'react'
import { Card } from '@themesberg/react-bootstrap';
import { Space, Table, Button as AntButton } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { useRecoilState, useSetRecoilState } from 'recoil';
import { EditorState } from "draft-js";
import { EditModal } from './Modal';
import { editTermConditionModal, editTermConditionVal, termConditionEditor, termConditionRefresh } from "../../../states/termCondition";

import { settingAlert, settingResponse } from '../../../states/settings';
import { getRawData } from '../../../services/utilities';
import confirm from 'antd/lib/modal/confirm';
import { deleteTerms } from '../../../services/apiCalls';

export default ({ data }) => {
  const setShowModal = useSetRecoilState(editTermConditionModal);
  const setResponse = useSetRecoilState(settingResponse)
  const [value, setValue] = useRecoilState(editTermConditionVal)
  const setEditor = useSetRecoilState(termConditionEditor)
  const setRefresh = useSetRecoilState(termConditionRefresh)
  const setShowAlert = useSetRecoilState(settingAlert);

  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Content',
      dataIndex: 'content',
      key: 'content',
      render: text => <p dangerouslySetInnerHTML={{ __html: text }} />
    },
    {
      title: 'Position',
      dataIndex: 'position',
      key: 'position',
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      render: (id, record) => (
        <Space size="middle">
          <AntButton type="ghost" onClick={() => handleCreate(record)}>Edit </AntButton>
          <AntButton type="danger" onClick={()=>confirmDelete(id)}>Delete</AntButton>
        </Space>
      ),
    },
  ];
  const handleCreate = (value) => {
    setValue(value)
    if (value.content) {
      const contentState = getRawData(value.content)
      setEditor(EditorState.createWithContent(contentState));
    }
    setShowModal(true)
    setResponse({})
  }
  const confirmDelete = (id) => {
    confirm({
      title: `Are you sure you want to delete this Privacy Policy?`,
      icon: <ExclamationCircleOutlined />,
      content: 'Click Ok to continue',
      onOk() {
        handleDelete(id)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const handleDelete = async (id) => {
    const date = new Date()
    const res = await deleteTerms(id)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
  }

  return (
    <Card border="light" className="table-wrapper table-responsive shadow-sm">
      <EditModal value={value} />
      <Card.Body className="pt-0">
        {data.map(b=>(
          <div key={b.id}>
            <h5 className='p-2 text-center'>{b.title}</h5>
            <p className='text-center' dangerouslySetInnerHTML={{ __html: b.content }} />
            <div size="middle" className=' text-center'>
              <AntButton type="ghost" className='me-2' onClick={() => handleCreate(b)}>Edit </AntButton>
              <AntButton type="danger" onClick={()=>confirmDelete(b.id)}>Delete</AntButton>
            </div>
          </div>
        ))}
        {/* <Table columns={columns} pagination={false} dataSource={data} rowKey="id" /> */}
      </Card.Body>
    </Card>
  );
};
